import React from "react";
import "./header.scss";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Bannercarousel from "./bannercarousel.js";

const header = () => {
  const settings = {
    dots: true,
    arrows: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    lazyload: true,
  };
  return (
    <div className="container-header">
      <div className="header-dekstop">
        <div className="header-mobile">
          <Slider {...settings}>
            {Bannercarousel.map((image, index) => (
              <img
                className="kartugambar"
                key={index}
                src={image}
                alt={`Courtyard ${index + 1}`}
              />
            ))}
          </Slider>
        </div>
      </div>
    </div>
  );
};

export default header;
